export const getValidationErrors = messages => {
  const errors = {};

  for (const { message, key } of messages) {
    errors[key.join('.')] = message;
  }

  return errors;
};
